// extracted by mini-css-extract-plugin
var _1 = "styles-module__accordionTitle___iwfpT";
var _2 = "styles-module__accordionWrapper___BTPaB";
var _3 = "styles-module__linePara___zlACk";
var _4 = "styles-module__link___hNCRi";
var _5 = "styles-module__listStyle___h7tKd";
var _6 = "styles-module__privacyPolicyLink___Yo5PI";
var _7 = "styles-module__rawHeader___mSrry";
var _8 = "styles-module__rawPara___YHQQJ";
var _9 = "styles-module__title___S0X2q";
export { _1 as "accordionTitle", _2 as "accordionWrapper", _3 as "linePara", _4 as "link", _5 as "listStyle", _6 as "privacyPolicyLink", _7 as "rawHeader", _8 as "rawPara", _9 as "title" }
